"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var MenuItem_1 = __importDefault(require("../../MenuItem"));
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    menuItem: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: theme.spacing(2)
    }
}); });
var emptyFn = function () { };
var VirtualMenuItem = function (_a) {
    var item = _a.item, _b = _a.selected, selected = _b === void 0 ? false : _b, _c = _a.onChange, onChange = _c === void 0 ? emptyFn : _c, style = _a.style;
    var internalClasses = useStyles();
    var handleChange = (0, react_1.useCallback)(function (e) {
        onChange(__assign(__assign({}, e), { target: __assign(__assign({}, e.target), { value: item === null || item === void 0 ? void 0 : item.key }) }));
    }, [item, onChange]);
    return (item ? (react_1.default.createElement(MenuItem_1.default, { classes: { root: internalClasses.menuItem }, selected: selected, onClick: handleChange, style: style }, item.value)) : null);
};
exports.default = react_1.default.memo(VirtualMenuItem);
